<template>
    <div>
        <el-dialog :visible.sync="dialogVisible" append-to-body :close-on-click-modal="false"
            :close-on-press-escape="false" :show-close="false" destroy-on-close>
            <div slot="title">
                <div class="title">标记地图打卡点</div>
                <div class="tips color-danger">双击添加打卡位置</div>
            </div>
            <div class="map-box" @dblclick="addMarker">
                <el-image :src="formData.map"></el-image>
                <div v-for="(item, index) in markers" :key="index">
                    <el-tooltip placement="top" :disabled="showTooltip">
                        <div slot="content">
                            {{ item.name }}
                            <el-button type="text" size="mini" @click="del(index)">删除</el-button>
                        </div>
                        <div class="marker" :style="{ left: `${item.left}%`, top: `${item.top}%` }">
                            <span class="el-icon-location"></span>
                        </div>
                    </el-tooltip>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancel()">取 消</el-button>
                <el-button type="primary" @click="submitAction()">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog width="350px" title="打卡地名称" :visible.sync="innerVisible" @close="close" append-to-body>
            <el-input v-model="marker.name" maxlength="16" placeholder="打卡地名称" show-word-limit></el-input>
            <span slot="footer" class="dialog-footer">
                <el-button @click="close()">取 消</el-button>
                <el-button :disabled="marker.name ? false : true" type="primary" @click="add()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
const _defaultMarker = {
    left: '',
    top: '',
    name: ''
}
export default {
    props: {
        formData: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            dialogVisible: false,
            innerVisible: false,

            // markers: [],

            marker: {
                ..._defaultMarker
            },
            showTooltip: false
        }
    },
    computed: {
        markers() {
            const _markers = [];
            this.formData.configList.map(v => {
                _markers.push({
                    name: v.name,
                    left: v.xy.split(',')[0],
                    top: v.xy.split(',')[1]
                })
            })
            return _markers;
        }
    },
    methods: {
        show() {

            if (this.formData.map) {
                this.markers.splice(0, this.markers.length);
                // const _markers = [];
                this.formData.configList.map(v => {
                    this.markers.push({
                        name: v.name,
                        left: v.xy.split(',')[0],
                        top: v.xy.split(',')[1]
                    })
                })
                // this.markers = _markers;

                this.dialogVisible = true;
            }
        },
        cancel(){
            this.innerVisible = false;
            this.dialogVisible = false;
        },
        addMarker(e) {
            if (e.target._prevClass == "el-icon-location") {
                return this.$message.error("同一地点不可重复添加");
            }
            const _boxWidth = e.target.width, _boxHeight = e.target.height;
            const _x = e.layerX, _y = e.layerY;
            this.marker.left = (_x / _boxWidth) * 100;
            this.marker.top = (_y / _boxHeight) * 100;

            this.innerVisible = true;

        },
        del(index) {
            // const _markers = this.markers.filter((v, i) => i !== index)
            // const _configList = [];
            // _markers.map(v => {
            //     _configList.push({
            //         name: v.name,
            //         xy: [v.left, v.top].toString()
            //     })
            // })
            // this.$set(this.formData, 'configList', _configList);
            this.showTooltip = true;
            this.markers.splice(index, 1);
            this.$forceUpdate();
            let t = setTimeout(() => {
                this.showTooltip = false;
                clearTimeout(t);
            },500)
        },
        add() {
            this.markers.push(this.marker)
            this.innerVisible = false
        },
        close() {
            this.marker = {
                ..._defaultMarker
            }
            this.innerVisible = false
        },
        submitAction() {
            if (this.markers.length < 1) {
                this.$message.error('请为地图标记打卡点');
                return;
            }
            const _configList = [];
            this.markers.map(v => {
                _configList.push({
                    name: v.name,
                    xy: [v.left, v.top].toString()
                })
            })
            this.$set(this.formData, 'configList', _configList);
            this.dialogVisible = false;
        }
    }
}
</script>
<style lang="scss" scoped>
.title {
    font-size: 16px;
    font-weight: 700;
}

.tips {
    margin-top: 10px;
}

.map-box {
    position: relative;
    display: inline-block;

    .marker {
        position: absolute;
        width: 30px;
        height: 30px;
        line-height: 30px;
        margin-left: -15px;
        margin-top: -30px;
        text-align: center;
        font-size: 30px;
        color: $--color-danger;
    }
}
</style>